import { useEffect, useRef, useState } from "react";
import { Button } from "primereact/button";
import { Fetch, baseUrl } from "../../shared/Fetch";
import { IECI } from "../../models/ECI";
import { Dialog } from "primereact/dialog";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { format } from "date-fns";
import { Toast } from "primereact/toast";
import { IAllRequirements } from "../../models/AllRequirements";
import { EmptyFilter, IReqFilter } from "../requirement/Filter";
// import { ILogin } from "../../models/Login";
import { InputTextarea } from "primereact/inputtextarea";
import { Dropdown } from "primereact/dropdown";
import { Tag } from "primereact/tag";
import { JVSunEditor } from "../../shared/JVSuneditor";
import { Publish } from "../pocTransferReq/Publish";
import { FloatNotification } from "./FloatNotification";
import { useNavigate } from 'react-router-dom';
import { useNotification } from "../../shared/NotificatonContext";
import { Job_Type, Req_Term } from "../../models/RequirementMast";

interface IProps {
    onTopbarNotification: () => void,
    toast: any,
}
export interface IModel2 {
    open: boolean,
    singleData: IAllRequirements
}

export const Notification = (props: IProps) => {
    const { connection } = useNotification();
    const [notificationCounts, setNotificationCounts] = useState<{
        eciScheduled: number,
        pocTransferReq: number,
        reqRateApproval: number,
        reqContrainsApproval: number,
        floatReq: number,
        subvendorTimesheet: number,
        consultantTimesheet: number
    }>({
        eciScheduled: 0,
        pocTransferReq: 0,
        reqRateApproval: 0,
        reqContrainsApproval: 0,
        floatReq: 0,
        subvendorTimesheet: 0,
        consultantTimesheet: 0
    });

    const [eciScheduleTable, setEciScheduleTable] = useState({ open: false, tableData: [], loading: false } as { open: boolean, tableData: Array<IECI>, loading: boolean });
    const [prevReqTableData, setPrevReqTableData] = useState({ tableData: [], loading: false, singleData: {} } as { tableData: Array<IAllRequirements>, loading: boolean, singleData: any });
    const [reqAlreadyExist, setReqAlreadyExist] = useState(false);

    const [pocTransferReqTable, setPocTransferReqTable] = useState({ open: false, tableData: [], loading: false } as { open: boolean, tableData: Array<IAllRequirements>, loading: boolean });

    const [openFloat, setOpenFloat] = useState<boolean>(false);
    const [acceptPoc, setAcceptPoc] = useState(false);
    const [rejrctionOpen, setRejrctionOpen] = useState({ req_ID: 0, open: false } as { req_ID: number, open: boolean });
    const dt = useRef<any>(null);
    const toast = useRef<any>(null);
    const reqFilter: IReqFilter = EmptyFilter;
    const [disable, setDisable] = useState<boolean>(false);
    const [rejectionReasonValue, setRejectionReasonValue] = useState("");
    const [selectedStatus, setSelectedStatus] = useState<any>(null);
    const [comment, setComment] = useState({ singleData: "", open: false } as { singleData: string, open: boolean });
    const [prevReqTableDataView, setPrevReqTableDataView] = useState(false);
    const [acptLoading, setAcptLoading] = useState(false);
    const [approveType, setApproveType] = useState(1);
    const [notificationPermisions, setNotificationPermisions] = useState<Array<string>>([]);
    const [messages, setMessages] = useState<string[]>([]);
    const navigate = useNavigate();

    const [publish, setPublish] = useState({ singleData: {}, open: false } as IModel2);
    const hidePublishDialog = () => {
        setPublish({ singleData: {}, open: false });
    };

    const [rrr, setRRR] = useState({ open: false, rrreason: "", req_ID: 0 } as { open: boolean, rrreason: string | undefined, req_ID: number | undefined });
    const hideRRRDialog = () => {
        setRRR({ open: false, rrreason: "", req_ID: 0 });
    };

    const [historyOpen, setHistoryOpen] = useState({ contact_PersonID: 0, req_Category: 0, open: false } as { contact_PersonID: number, req_Category: number, open: boolean });
    const [historyTableData, setHistoryTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IAllRequirements>, loading: boolean });

    const _roles: Array<number> = [];
    const loginObj = JSON.parse(sessionStorage.getItem('auth') + '');
    const loginId: number = loginObj.id;
    loginObj.roles.forEach((role: { role_ID: number }) => {
        _roles.push(role.role_ID);
    });

    const notificationPermisionsData = () => {
        const arr = notificationPermisions;
        loginObj.page?.forEach((element: any) => {
            if (element.pageURL === "eciScheduleNotify" || element.pageURL === "pocTransferReqNotify" || element.pageURL === "reqRateApproveNotify" || element.pageURL === "specialConstraintsReqNotify" || element.pageURL === "floatRequirementNotification" || element.pageURL === "timesheetAddedCount") {
                if (element.is_View > 0) {
                    arr.push(element.pageURL);
                }
            }
        });
        setNotificationPermisions(arr);
    };

    const statusOptions: { rejection_Reason: string, value: number }[] = [
        { rejection_Reason: "-- SELECT --", value: 0 },
        { rejection_Reason: 'Already Posted', value: 1 },
        { rejection_Reason: 'Repeated', value: 2 },
        { rejection_Reason: 'Not Workable', value: 3 },
        { rejection_Reason: 'Others', value: 4 }
    ];

    const loadEciScheduleCount = async () => {
        const response = await Fetch("eci/scheduledCount", "GET", null, null, props.toast);
        if (response) {
            const data: number = parseInt(await response.text(), 0);
            setNotificationCounts(prev => ({ ...prev, eciScheduled: data }));
        };
    }

    const loadPocTransferReqCount = async () => {
        if (notificationPermisions.includes("pocTransferReqNotify")) {
            let response = await Fetch("POCTransferReq/pocrequirementscount", "GET", null, `filter=${JSON.stringify(reqFilter)}&tb=${3}&poc_req=yes&Req_Type_POC=${1}`, props.toast);
            if (response) {
                const data: number = parseInt(await response.text(), 0);
                setNotificationCounts(prev => ({ ...prev, pocTransferReq: data }));
            }
        }
    }
    const loadReqRateApprovalCount = async () => {
        if (notificationPermisions.includes("reqRateApproveNotify")) {
            let response = await Fetch("POCTransferReq/pocrequirementscount", "GET", null, `filter=${JSON.stringify(reqFilter)}&tb=${3}&poc_req=yes&Req_Type_POC=${2}`, props.toast);
            if (response) {
                const data: number = parseInt(await response.text(), 0);
                setNotificationCounts(prev => ({ ...prev, reqRateApproval: data }));
            }
        }
    }
    const loadReqContrainsApprovalCount = async () => {
        if (notificationPermisions.includes("specialConstraintsReqNotify")) {
            let response = await Fetch("POCTransferReq/pocrequirementscount", "GET", null, `filter=${JSON.stringify(reqFilter)}&tb=${3}&poc_req=yes&Req_Type_POC=${3}`, props.toast);
            if (response) {
                const data: number = parseInt(await response.text(), 0);
                setNotificationCounts(prev => ({ ...prev, reqContrainsApproval: data }));
            }
        }
    }
    const loadFloatReqCount = async () => {
        if (notificationPermisions.includes("floatRequirementNotification")) {
            const response = await Fetch("Float/floatCount", "GET", null, null, props.toast);
            if (response) {
                const data: number = parseInt(await response.text(), 0);
                setNotificationCounts(prev => ({ ...prev, floatReq: data }));
            }
        }
    }
    const loadTimesheetAddedCount = async () => {
        const response = await Fetch("Timesheet/getTimesheetAddedCount", "GET", null, `loginID=${loginObj.id}`, null);
        if (response) {
            const data: {
                consultant_Count?: number,
                consultant_Added?: any[],
                subvendor_Count?: number,
                subvendor_Added?: any[]
            } = await response.json();
            setNotificationCounts(prev => ({ ...prev, subvendorTimesheet: data?.consultant_Count || 0, consultantTimesheet: data.consultant_Count || 0 }));
        }
    }

    const loadEciScheduleTable = async () => {
        if (notificationPermisions.includes("eciScheduleNotify")) {
            setEciScheduleTable(prev => ({ ...prev, loading: true, open: true }));
            const response = await Fetch("ECI/scheduled", "GET", null, null, null);
            if (response) {
                const data: Array<IECI> = await response.json();
                let newData = data.filter((e) => {
                    const st = new Date;
                    const time: string[] | undefined = e.ecI_Time_AT?.trim().split(":") || ['00', '00'];
                    st.setHours(Number(time[0]), Number(time[1]), 0, 0);
                    const stss = new Date(`${e.eciDate?.split("/")[1]}/${e.eciDate?.split("/")[0]}/${e.eciDate?.split("/")[2]}`);
                    const currentTime = new Date;
                    const timeDiff = e.time_diff || 0;
                    currentTime.setHours(currentTime.getHours() - timeDiff);
                    stss.setHours(currentTime.getHours() + 1, currentTime.getMinutes(), 0, 0);
                    if (currentTime <= st && st <= stss) {
                        return e;
                    }
                });
                setEciScheduleTable(prev => ({ ...prev, loading: false, tableData: newData }));
            } else setEciScheduleTable(prev => ({ ...prev, loading: false }));
        }
    }
    const loadPocTransferReqTable = async (Req_Type_POC: number = 1) => {
        if (notificationPermisions.includes("pocTransferReqNotify") || notificationPermisions.includes("reqRateApproveNotify") || notificationPermisions.includes("specialConstraintsReqNotify")) {
            setPocTransferReqTable(prev => ({ ...prev, loading: true, open: true }));
            const response = await Fetch("POCTransferReq/pocrequirements", "GET", null, `filter=${JSON.stringify(reqFilter)}&tb=${3}&poc_req=yes&Req_Type_POC=${Req_Type_POC}`, props.toast);
            if (response) {
                const data: Array<IAllRequirements> = await response.json();
                setPocTransferReqTable(prev => ({ ...prev, loading: false, tableData: data }));
                setApproveType(Req_Type_POC || 1);
            } else setPocTransferReqTable(prev => ({ ...prev, loading: false }));
        }
    }

    const getPreviousReq = async (data: any) => {
        setPrevReqTableData({ tableData: prevReqTableData.tableData, loading: true, singleData: prevReqTableData.singleData });
        const response = await Fetch("POCTransferReq/getPreviousReq", "GET", null, `Email=${data.contact_Person_EmailIDSearch}&Category=${data.req_Category}&Req_Id=${data.req_ID}`, props.toast);
        if (response) {
            const respdata: any = await response.json();
            setPrevReqTableData({ tableData: respdata.req, loading: false, singleData: data });
            setPrevReqTableDataView(true);
            if (respdata.available === false) {
                setReqAlreadyExist(true);
            }
            else if (acceptPoc) {
            }
            else {
                toast.current.show({ severity: 'error', summary: 'error', detail: 'Requirement can not be accepted, Requirement Already Exist' });
                setReqAlreadyExist(false);
            }
            setDisable(false);
        } else {
            setPrevReqTableData({ tableData: prevReqTableData.tableData, loading: false, singleData: prevReqTableData.singleData });
            toast.current.show({ severity: 'error', summary: 'error', detail: 'Something went wrong, Please try again' });
            setDisable(false);
        }
    }

    const acceptedPoc = async (data: any) => {
        setAcptLoading(true);
        const response = await Fetch("POCTransferReq/acceptedByRecruiterHead", "POST", { req_ID: data.req_ID }, null, toast);
        if (response) {
            OnHide();
            toast.current.show({ severity: 'success', summary: 'success', detail: 'Requirement Accepted' });
            setPrevReqTableDataView(false);
            loadPocTransferReqTable(approveType);
            setAcptLoading(false);
        } else {
            setAcptLoading(false);
        }
    }

    const rejectdPoc = async (req_ID: number) => {
        setAcptLoading(true);
        const response = await Fetch("POCTransferReq/rejectedByRecruiterHead", "POST", { req_ID: req_ID, reason: rejectionReasonValue, status: selectedStatus }, null, props.toast);
        if (response) {
            toast.current.show({ severity: 'info', summary: 'success', detail: 'Requirement Rejected' })
            setDisable(false);
            loadPocTransferReqTable(approveType);
            setRejrctionOpen({ req_ID: 0, open: false });
            onHideReason();
            setAcptLoading(false);
            setPrevReqTableDataView(false);
        } else {
            setDisable(false);
            setAcptLoading(false);
            setPrevReqTableDataView(false);
        }
    }


    const onHidePocReqTable = () => {
        setPocTransferReqTable(prev => ({ ...prev, open: false }))
        setPrevReqTableDataView(false);
    }

    const AddHours = (rowData: IECI) => {
        const st = new Date;
        const time: string[] | undefined = rowData.ecI_Time_AT?.trim().split(":") || ['00', '00'];
        st.setHours(Number(time[0]), Number(time[1]), 0, 0);

        const sts = new Date;
        sts.setHours(sts.getHours() + 3, Number(time[1]), 0, 0);

        const stss = new Date(`${rowData.eciDate?.split("/")[1]}/${rowData.eciDate?.split("/")[0]}/${rowData.eciDate?.split("/")[2]}`);
        const currentTime = new Date;
        const timeDiff = rowData.time_diff || 0;
        currentTime.setHours(currentTime.getHours() - timeDiff);
        stss.setHours(currentTime.getHours() + 1, currentTime.getMinutes(), 0, 0);
        // currentTime <= st && st <= stss
        // return st >= new Date && st <= sts;
        //return st >= new Date && st <= sts && st <= stss;
        return currentTime <= st && st <= stss;
    }

    const rowClass = (data: IECI) => {
        return { 'bg-pink-500 text-white': AddHours(data) };
    }

    const getHistoryTable = async (data: IAllRequirements) => {
        const response = await Fetch("POCTransferReq/getTodayPOC", "GET", null, `Contact_PersonID=${data.pV_Contact_PersonID}&Req_Category=${data.req_Category}&Req_ID=${data.req_ID}`, props.toast);
        if (response) {
            const data: Array<IAllRequirements> = await response.json();
            setHistoryTableData({ tableData: data, loading: false });
        } else setHistoryTableData({ tableData: historyTableData.tableData, loading: false });

    }

    const actionBodyTemplate = (rowData: any) => {
        if (rowData.is_POC_already_Exist == true) { setAcceptPoc(true) }
        return (<div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
            <Button className="p-button-sm my-1 bg-green-500" disabled={disable} icon="pi pi-check" tooltip="Accept" onClick={() => { getPreviousReq(rowData); setDisable(true); rowData.is_POC_already_Exist == true ? setAcceptPoc(true) : setAcceptPoc(false) }} type="button"></Button>
            <Button className="p-button-sm p-button-danger my-1" icon="pi pi-times" tooltip="Reject" type="button" onClick={() => setRejrctionOpen({ req_ID: rowData.req_ID, open: true })}></Button>
            <Button className="p-button-sm my-1 surface-600" icon="pi pi-history" tooltip="History" type="button" onClick={() => { getHistoryTable(rowData); setHistoryOpen({ contact_PersonID: rowData.pV_Contact_PersonID, req_Category: rowData.req_Category, open: true }) }}></Button>
        </div>);
    }

    const onHideReason = () => {
        setRejrctionOpen({ req_ID: 0, open: false });
        setRejectionReasonValue("");
        setSelectedStatus(null);
        setDisable(false);
    }

    const onRejectPoc = () => {
        if (selectedStatus === null || selectedStatus === 0) {
            toast.current.show({ severity: 'error', detail: 'Please Select a Status' });
            setDisable(false);
        } else {
            rejectdPoc(rejrctionOpen.req_ID);
            setDisable(true);
        }
    }


    const req_Job_Title = (rowData: IAllRequirements) => {
        return rowData.poC_Transfer_Req === 3 ?
            <span onClick={() => {
                setPublish({ singleData: rowData, open: true });
            }}
                className="cursor-pointer underline">
                <Tag severity="danger" value={rowData.req_Job_Title} />
            </span>
            : rowData.poC_Transfer_Req == 2 ? <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer underline">
                <Tag severity="success" value={rowData.req_Job_Title} />
            </span> : <span onClick={() => setPublish({ singleData: rowData, open: true })}
                className="cursor-pointer text-cyan-700 underline">
                {rowData.req_Job_Title}
            </span>;
    };


    // useEffect(() => {
    //     notificationPermisionsData();
    //     loadEciScheduleCount();
    //     loadPocTransferReqCount();
    //     loadReqRateApprovalCount();
    //     loadReqContrainsApprovalCount();
    //     loadFloatReqCount();
    //     loadTimesheetAddedCount();
    // }, []);

    // useEffect(() => {
    //     const interval = setInterval(() => {
    //         loadEciScheduleCount();
    //     }, 1000 * 60 * 10);
    //     return () => clearInterval(interval);
    // }, []);


    useEffect(() => {
        if (!connection) return;

        connection?.on("OnActivity", (data: { activityType: string, isTargetAll?: boolean, targets?: number[], message?: string }) => {
            switch (data.activityType) {
                case 'Notification':
                    if (data.isTargetAll || data.targets?.includes(loginId))
                        setMessages(prev => [...prev, data.message!]);
                    break;
                case 'Logout':
                    if (data.isTargetAll || data.targets?.includes(loginId)) {
                        sessionStorage.clear();
                        navigate('/');
                    }
                    break;
                case 'Message':
                    if (data.isTargetAll || data.targets?.includes(loginId))
                        setMessages(prev => [...prev, data.message!]);
                    break;
                // case 'PocTransfReq':
                //     if (data.targets?.includes(loginId))
                //         loadPocTransferReqCount();
                //     break;
                // case 'ReqRateApp':
                //     if (data.targets?.includes(loginId))
                //         loadReqRateApprovalCount();
                //     break;
                // case 'ReqConstApp':
                //     if (data.targets?.includes(loginId))
                //         loadReqContrainsApprovalCount();
                //     break;
                // case 'FloatReq':
                //     if (data.targets?.includes(loginId))
                //         loadFloatReqCount();
                //     break;
                // case 'TimesheetAdded':
                //     if (data.targets?.includes(loginId))
                //         loadTimesheetAddedCount();
                //     break;
            }
        });

        return () => {
            connection?.off("OnActivity");
        };
    }, [connection]);

    const Mode_Of_Req_Body = (rowData: any) => {
        return <p>{rowData.mode_Of_Req === "Portal" ? "Portal" :
            (rowData.mode_Of_Req === "Mail" ? "Mail" :
                (
                    rowData.mode_Of_Req === "Other" ? <span onClick={() => setComment({ singleData: rowData.mode_Of_Req_Comment, open: true })} className="cursor-pointer text-cyan-700 underline">Other</span> : ""
                )
            )
        }</p>
    }

    const downloadScreenShot = async (req_ID: number) => {
        const params = {
            method: "GET",
            headers: {
                'Content-Type': 'image/png',
                'Authorization': `Bearer ${JSON.parse(sessionStorage.getItem('auth') + "")?.token}`
            }
        };
        try {
            const response = await fetch(`${baseUrl}${"POCTransferReq/download"}?req_ID=${req_ID}`, params);
            if (response.status === 200) {
                const blob = await response.blob();
                const href = window.URL.createObjectURL(blob);
                const a = document.createElement("a");
                a.download = `${req_ID}.png`;
                a.href = href;
                a.click();
                a.href = '';
            } else if (response.status === 400) {
                const message = await response.text();
                props.toast.current.show({ severity: 'error', detail: message, life: 3000 });
            }
        } catch {
            props.toast.current.show({ severity: 'error', detail: 'Something went Wrong', life: 3000 });
        }
    }
    const downloadSS = (rowData: any) => {
        return <Button icon="pi pi-download" className="p-button-rounded p-button-success p-button-text mr-1" onClick={() => { if (rowData.req_ID) downloadScreenShot(rowData.req_ID); }} />
    }

    const pDate = (rowData: IAllRequirements) => {
        let date;
        if (rowData.pDate) date = format(new Date(rowData.pDate), 'dd/MM/yyyy').toUpperCase();
        else date = "";
        return (<>{date}</>);
    };

    const OnHide = () => {
        setPrevReqTableDataView(false);
        setReqAlreadyExist(false);
        setPrevReqTableData({ tableData: [], loading: false, singleData: {} });
        setDisable(false);
    }

    //  ------------ FLOAT START ------------------

    const loadFloatReqTable = async () => {
        const response = await Fetch("Float", "GET", null, null, props.toast);
        if (response) {
            const data: Array<IAllRequirements> = await response.json() || [];
            // setFloatCount(data.length);
        }
    }

    // const loadReqApproveData = async () => {
    //     const response = await Fetch("POCTransferReq/pocrequirements", "GET", null, `Req_Type_POC=${2}`, props.toast);
    //     if (response) {
    //         const data: Array<IAllRequirements> = await response.json();
    //         setReqApproveCount(data.length)

    //     } 
    // }

    // const loadSpecialConsApproveData = async ()=>{
    //     setEciScheduleTable({ tableData: tableData.tableData, loading: true });
    //     const _roles: Array<number> = [];
    //     const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    //     loginObj.roles.forEach(role => {
    //         _roles.push(role.role_ID);
    //     });
    //     const IsPage = _roles.includes(4) ? "&is_Page=yes" : "";

    //     const response = await Fetch("POCTransferReq/pocrequirements", "GET", null, `filter=${JSON.stringify(reqFilter)}&tb=${3}&Req_Type_POC=${3}` + IsPage, props.toast);
    //     if (response) {
    //         const data: Array<IAllRequirements> = await response.json();
    //         setSpecialConsCount(data.length);
    //     } 
    // }

    const OnHideFloat = () => {
        setOpenFloat(false);
    }

    // const onHideReqApprove =()=>{
    //     setOpenReqApprove(false);
    // }

    // const onHideSpecialConsApprove =()=>{
    //     setopenSpecialConsApprove(false);
    // }


    // useEffect(() => {
    //     if (_roles.includes(1) || _roles.includes(5) || _roles.includes(2) || _roles.includes(26)) loadFloatDataCount();
    // }, []);

    //  ------------ FLOAT END ---------------------
    //if (element.pageURL === "eciScheduleNotify" || element.pageURL === "pocTransferReqNotify" || element.pageURL === "reqRateApproveNotify" || element.pageURL === "specialConstraintsReqNotify" || element.pageURL === "floatRequirementNotification")

    const totalNotifications = notificationCounts.eciScheduled + notificationCounts.pocTransferReq + notificationCounts.floatReq + notificationCounts.reqRateApproval + notificationCounts.reqContrainsApproval;

    return (
        <>
            <button type="button" className="p-link" onClick={props.onTopbarNotification}>
                <i className="pi pi-bell"></i>
                {totalNotifications > 0 && <span className="topbar-badge" >{totalNotifications}</span>}
            </button>
            <ul className="notifications-menu fade-in-up">
                <li role="menuitem">
                    {notificationPermisions.includes("eciScheduleNotify") && <button type="button" className="p-link" tabIndex={0} onClick={() => loadEciScheduleTable()}>
                        <i className=""></i>
                        <div className="notification-item">
                            <div className="notification-summary">ECI Scheduled - <span style={{ color: notificationCounts.eciScheduled > 1 ? "red" : "black" }}>{notificationCounts.eciScheduled}</span></div>
                        </div>
                    </button>}
                </li>
                <li>
                    {notificationPermisions.includes("pocTransferReqNotify") && (_roles.includes(1) || _roles.includes(26) || _roles.includes(4)) && <button type="button" className="p-link" tabIndex={0} onClick={() => loadPocTransferReqTable()}>
                        <i className=""></i>
                        <div className="notification-item">
                            <div className="notification-summary">Poc Transfer Req - <span style={{ color: notificationCounts.pocTransferReq > 1 ? "red" : "black" }}>{notificationCounts.pocTransferReq}</span></div>
                        </div>
                    </button>}
                </li>
                <li>
                    {notificationPermisions.includes("reqRateApproveNotify") && (_roles.includes(1) || _roles.includes(26) || _roles.includes(4)) && <button type="button" className="p-link" tabIndex={0} onClick={() => loadPocTransferReqTable(2)}>
                        <i className=""></i>
                        <div className="notification-item">
                            <div className="notification-summary">Req Rate Approve - <span style={{ color: notificationCounts.reqRateApproval > 1 ? "red" : "black" }}>{notificationCounts.reqRateApproval}</span></div>
                        </div>
                    </button>}
                </li>
                <li>
                    {notificationPermisions.includes("specialConstraintsReqNotify") && (_roles.includes(1) || _roles.includes(26) || _roles.includes(4)) && <button type="button" className="p-link" tabIndex={0} onClick={() => loadPocTransferReqTable(3)}>
                        <i className=""></i>
                        <div className="notification-item">
                            <div className="notification-summary">Special Constraints Req - <span style={{ color: notificationCounts.reqContrainsApproval > 1 ? "red" : "black" }}>{notificationCounts.reqContrainsApproval}</span></div>
                        </div>
                    </button>}
                </li>
                <li>
                    {notificationPermisions.includes("floatRequirementNotification") && (_roles.includes(1) || _roles.includes(26) || _roles.includes(2) || _roles.includes(5)) && <button type="button" className="p-link" tabIndex={0} onClick={() => setOpenFloat(true)}>
                        <i className=""></i>
                        <div className="notification-item">
                            <div className="notification-summary">Float  Requirement - <span style={{ color: notificationCounts.floatReq > 1 ? "red" : "black" }}>{notificationCounts.floatReq}</span></div>
                        </div>
                    </button>}
                </li>
                <li>
                    {notificationPermisions.includes("timesheetAddedCount") && <button type="button" className="p-link" tabIndex={0} >
                        <i className=""></i>
                        <div className="notification-item">
                            <div className="notification-summary">Timesheets Added By Subvendor Today - <span style={{ color: notificationCounts.subvendorTimesheet > 1 ? "red" : "black" }}>{notificationCounts.subvendorTimesheet}</span></div>
                        </div>
                    </button>}
                </li>
                <li>
                    {notificationPermisions.includes("timesheetAddedCount") && <button type="button" className="p-link" tabIndex={0} >
                        <i className=""></i>
                        <div className="notification-item">
                            <div className="notification-summary">Timesheets Added By Consultant Today - <span style={{ color: notificationCounts.consultantTimesheet > 1 ? "red" : "black" }}>{notificationCounts.consultantTimesheet}</span></div>
                        </div>
                    </button>}
                </li>
            </ul>

            {messages.length > 0 && <div style={{ backgroundColor: '#FFF', padding: 8, position: 'fixed', right: 0, top: 60, width: '100vw', maxWidth: '400px', borderRadius: 8, boxShadow: 'rgba(255, 255, 255, 0.1) 0px 1px 1px 0px inset, rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px' }}>
                {messages.map((m, i) => (
                    <div key={i} style={{ marginLeft: 'auto', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', paddingTop: 6, paddingBottom: 6 }}>
                        <span style={{ display: 'inline-block', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: 16 }}>{m}</span>
                        <Button onClick={() => setMessages(prev => prev.filter(f => f !== m))} icon="pi pi-times" aria-label="Remove" className="p-button-sm p-button-text p-button-danger m-0 p-0" />
                    </div>
                ))}
            </div>}

            {/*------------------------------- For ECI Scheduled Model Start ----------------------------------------*/}

            <Dialog visible={eciScheduleTable.open} style={{ width: '80vw' }} header="ECI's" modal className="p-fluid" onHide={() => setEciScheduleTable(prev => ({ ...prev, open: false }))}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    size="small" stripedRows showGridlines responsiveLayout="scroll"
                    value={eciScheduleTable.tableData}
                    header={''}
                    loading={eciScheduleTable.loading}
                    rowClassName={rowClass}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="req_ID" header="Req.ID" sortable />
                    <Column field="salesmanager" header="Sales Manager" sortable />
                    <Column field="salesBranchName" header="Branch" sortable />
                    <Column field="user_Name" header="Recruiter" sortable />
                    <Column field="recruiterBranchName" header="Branch" sortable />
                    <Column field="consultant_Name" header="Consultant Name" sortable />
                    <Column field="eciDate" header="Int. Date" sortable />
                    <Column field="ecI_Time" header="Int. Time" />
                    <Column field="time_Zone_Name" header="Zone" sortable />
                </DataTable>
            </Dialog>
            {/*------------------------------- For ECI Scheduled Model End ----------------------------------------*/}


            {/*------------------------------- For Poc Transfer Req Model Start ----------------------------------------*/}

            {(_roles.includes(4) || _roles.includes(1) || _roles.includes(26) || _roles.includes(12)) &&
                <Dialog visible={pocTransferReqTable.open} style={{ width: '80vw' }} header={approveType == 1 ? "POC Approval" : approveType == 2 ? "Minimum Rate Approval" : "Special Constraint Approval"} modal className="p-fluid" onHide={onHidePocReqTable}>
                    <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                        ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                        value={pocTransferReqTable.tableData}
                        emptyMessage="No Requirements found."
                        header={''}
                        loading={pocTransferReqTable.loading}
                    >
                        <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                        <Column field="approved_Req_ID" header="Req.ID" sortable />
                        <Column field="user_Name" sortable header="Sales Manager" />
                        <Column field="" header="Sales Comp(Branch)" body={(rowData: any) => <span>{rowData.salesCompany.split(" ")[0] + " (" + rowData.salesBranch + ")"}</span>} />
                        <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                        <Column field="req_Duration" header="Duration" />
                        <Column field="location" header="Location" />
                        <Column field="req_CategoryName" header="Category" sortable />
                        <Column field="req_Sub_CategoryName" header="Sub Category" sortable />
                        <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                        <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                        <Column field="pDate" header="Posted On" body={pDate} />
                        <Column field="req_EndClient" sortable header="End Client" />
                        {!((_roles.includes(3) || _roles.includes(4) || _roles.includes(34) || _roles.includes(12))) && <Column field="client" sortable header="Client" />}

                        {approveType != 1 && <Column field="special_Constraint" header="Special Constraints" />}
                        {approveType != 1 && <Column field="minimum_Rate" header="Minimum Rate" body={(rowdata: IAllRequirements) => (<div title="Minimum Rate">{(rowdata.for_Rate_Approve) ? <Tag severity="danger" value={rowdata.minimum_Rate} /> : (rowdata.minimum_Rate)}</div>)} />}
                        {approveType != 1 && <Column field="req_Rate" header="Req Rate" body={(rowdata: IAllRequirements) => (<div title="Req Rate">{(rowdata.approved_Req_ID) ? (<Tag severity="success" value={rowdata.req_Rate} />) : (rowdata.req_Rate)}</div>)} />}

                        {!((_roles.includes(3) || _roles.includes(4) || _roles.includes(34) || _roles.includes(12))) && <Column field="contact_Person_Name" header="Contact Person" />}
                        <Column field="client_Communication" header="Client Communication" />
                        <Column field="mode_Of_Req" header="Mode Of Requirement" body={Mode_Of_Req_Body} />

                        {approveType == 1 && <Column header="Screen Shot" body={downloadSS} />}

                        <Column header="Action" body={actionBodyTemplate} />
                    </DataTable>
                </Dialog>}
            {/*------------------------------- For Poc Transfer Req Model End ----------------------------------------*/}

            {/*--------------------------- For Job Title Poc Transfer Req Model Start ------------------------------------*/}
            <Publish singleData={publish.singleData} open={publish.open} hideDialog={hidePublishDialog} toast={props.toast} />
            {/*--------------------------- For Job Title Poc Transfer Req Model End --------------------------------------*/}
            {/*--------------------------- For Poc Transfer Req Rejection Model Start ------------------------------------*/}
            <Dialog visible={rejrctionOpen.open} style={{ width: '50vw' }} header="Requirement Rejection Reason" modal className="p-fluid" onHide={onHideReason}>
                <Dropdown value={selectedStatus} onChange={(e) => setSelectedStatus(e.value)} options={statusOptions} optionLabel="rejection_Reason" placeholder="Select a Status" className="w-full md:w-14rem" />
                {(selectedStatus === 4 && <> <InputTextarea value={rejectionReasonValue} onChange={(e) => setRejectionReasonValue(e.target.value)} rows={14} cols={30} />
                    {rejectionReasonValue.length <= 9 && <small className="p-error" >Minimum 10 Characters Required*</small>}
                </>)}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '20px', marginTop: '25px' }}>
                    <Button className="p-button-sm p-button-danger my-1" disabled={disable || selectedStatus === 0 || (selectedStatus === 4 ? rejectionReasonValue.length <= 9 : (selectedStatus === null ? true : false))} label="REJECT" onClick={onRejectPoc} type="button"></Button>
                    <Button className="p-button-sm p-button-outlined my-1" label="CLOSE" onClick={onHideReason} type="button"></Button>
                </div>
            </Dialog>
            {/*--------------------------- For Poc Transfer Req Rejection Model End ------------------------------------*/}
            <Dialog visible={rrr.open} style={{ width: '80vw' }} header={`Requirement - (${rrr.req_ID}) Rejection Reason`} className="p-fluid" onHide={hideRRRDialog}>
                <JVSunEditor value={rrr.rrreason} />
            </Dialog>
            <Dialog visible={comment.open} style={{ width: '40vw' }} header={`Requirement Comment`} className="p-fluid" onHide={() => setComment({ singleData: comment.singleData, open: false })}>
                <div className="border-1 p-4 border-round surface-border">{comment.singleData}</div>
            </Dialog>

            {/*--------------------------- For Poc Transfer Req Accept Model Start ------------------------------------*/}
            {prevReqTableDataView && <Dialog visible={prevReqTableDataView} style={{ width: '80vw' }} header="Reqs Posted with this Client Today" modal className="p-fluid" onHide={OnHide}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll"
                    //exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    value={prevReqTableData.tableData}
                    emptyMessage="No Requirements found."
                    header={''}
                    loading={prevReqTableData.loading}
                    rowClassName={(data) => ({
                        'bg-pink-100 font-semibold': data.requesting === true,
                    })}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="req_ID" header="Req.ID" sortable />
                    <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                    <Column field="req_Duration" header="Duration" />
                    <Column field="location" header="Location" />
                    <Column field="req_CategoryName" header="Category" sortable />
                    <Column field="req_Sub_CategoryName" header="Sub Category" sortable />
                    <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                    <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                    <Column field="createdAt" header="Created On" body={(e) => <p>{format(new Date(e.pDate), 'dd/MM/yyyy').toUpperCase()}</p>} />
                    <Column field="user_Name" sortable header="Sales Manager" />
                    <Column field="recruiter" header="Recruiter" />
                    <Column field="req_EndClient" sortable header="End Client" />
                    <Column field="client_Communication" sortable header="Client Communication" />
                </DataTable>
                {/* {reqAlreadyExist === true && <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                    <Button className="p-button-sm my-1 bg-green-500" loading={acptLoading} disabled={acptLoading} label="Accept" onClick={() => { acceptedPoc(prevReqTableData.singleData); }} type="button"></Button>
                    <Button className="p-button-sm p-button-danger my-1" loading={acptLoading} disabled={acptLoading} label="Reject" type="button" onClick={() => setRejrctionOpen({ req_ID: prevReqTableData.singleData.req_ID, open: true })}></Button>
                </div>}
                {(acceptPoc == true) && <><div className="text-xl underline" style={{ color: "Red", fontWeight: "bolder" }}>Requirements is Already Posted.  Do You Really Want to Accept this POC?</div>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                    
                    <Button className="p-button-sm my-1 bg-green-500" label="Accept" loading={acptLoading} onClick={() => { acceptedPoc(prevReqTableData.singleData); }} type="button"></Button>
                    <Button className="p-button-sm p-button-danger my-1" label="Reject" loading={acptLoading} type="button" onClick={() => setRejrctionOpen({ req_ID: prevReqTableData.singleData.req_ID, open: true })}></Button>
                </div></>} */}
                <>
                    {/* {acceptPoc == true && <div className="text-xl underline" style={{ color: "Red", fontWeight: "bolder" }}>Requirements is Already Posted.  Do You Really Want to Accept this POC?</div>} */}
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', columnGap: '10px', marginTop: '5px' }}>
                        <Button className="p-button-sm my-1 bg-green-500" label="Accept" loading={acptLoading} onClick={() => { acceptedPoc(prevReqTableData.singleData); }} type="button"></Button>
                        <Button className="p-button-sm p-button-danger my-1" label="Reject" loading={acptLoading} type="button" onClick={() => setRejrctionOpen({ req_ID: prevReqTableData.singleData.req_ID, open: true })}></Button>
                    </div></>
            </Dialog>}
            {/*--------------------------- For Poc Transfer Req Accept Model End ------------------------------------*/}

            <FloatNotification open={openFloat} toast={toast} onHide={OnHideFloat} />
            {/* <ReqApproveNotification open={openReqApprove} toast={toast} onHide={onHideReqApprove} loadReqApproveData={loadReqApproveData}/>
            <SpecialConstraintNotification open={openSpecialConsApprove} toast={toast} onHide={onHideSpecialConsApprove} loadSpecialConsApproveData={loadSpecialConsApproveData} /> */}
            <Toast ref={toast} />

            <Dialog visible={historyOpen.open} style={{ width: '80vw' }} header="Requirement Posted  History" modal className="p-fluid" onHide={() => { setHistoryOpen({ contact_PersonID: 0, req_Category: 0, open: false }); }}>
                <DataTable style={{ border: '1px solid rgba(105,105,105,0.17)', borderTopWidth: "0", marginTop: "5px" }}
                    ref={dt} size="small" stripedRows showGridlines responsiveLayout="scroll" exportFilename={format(new Date(), 'dd-MM-yyyy hh_mm_ss a').toUpperCase()}
                    resizableColumns columnResizeMode="expand"
                    scrollable scrollHeight="30vh"
                    value={historyTableData.tableData}
                    emptyMessage="No Requirements found."

                    loading={historyTableData.loading}
                >
                    <Column field="sn" header="SN" body={(rowData, options) => options.rowIndex + 1} />
                    <Column field="approved_Req_ID" header="Req.ID" sortable />
                    <Column field="req_Job_Title" sortable header="Job Title" body={req_Job_Title} />
                    <Column field="req_Duration" header="Duration" />
                    <Column field="location" header="Location" />
                    <Column field="req_CategoryName" header="Category" sortable />
                    <Column field="req_Term" header="Job Term" body={(rowData: IAllRequirements) => rowData.req_Term ? Req_Term[rowData.req_Term] : ""} />
                    <Column field="job_Type" header="Job Type" body={(rowData: IAllRequirements) => rowData.job_Type ? Job_Type[rowData.job_Type] : ""} />
                    <Column field="pDate" header="Posted On" body={(e) => <p>{format(new Date(e.pDate), 'dd/MM/yyyy').toUpperCase()}</p>} />
                    <Column field="user_Name" sortable header="Sales Manager" />
                    <Column field="recruiter" header="Recruiter" />
                    <Column field="req_EndClient" sortable header="End Client" />
                    <Column field="client_Communication" sortable header="Client Communication" />
                </DataTable>
            </Dialog>
        </>
    );
}